import { useParams, useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import axios from "../../api/axios";
import logo from "./image.png";

const ResetPassword = () => {

   const { token } = useParams();
   const navigate = useNavigate();

   const onFinish = (values) => {

      axios.post(`/reset-password/${token}`, values)
         .then(() => {
            message.success("Password reset successful");
            navigate("/");
         })
         .catch(() => message.error("Invalid or expired link"));
   };

   return (
      <div
         style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f4f5f7"
         }}
      >

         <div
            style={{
               width: 420,
               padding: 40,
               borderRadius: 12,
               background: "#fff",
               boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
               textAlign: "center"
            }}
         >

            {/* LOGO */}
            {/* <div
               style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20
               }}
            >
               <img
                  src={logo}
                  alt="logo"
                  style={{
                     width: 120
                  }}
               />
            </div> */}

            <h2
               style={{
                  color: "#5f3dc4",
                  marginBottom: 30,
                  fontWeight: 600
               }}
            >
               Reset password
            </h2>

            <Form layout="vertical" onFinish={onFinish}>

               <Form.Item
                  name="password"
                  rules={[
                     { required: true, message: "Enter new password" },
                     { min: 6, message: "Password must be at least 6 characters" }
                  ]}
               >
                  <Input.Password
                     placeholder="New Password"
                     size="large"
                     style={{ borderRadius: 10 }}
                  />
               </Form.Item>

               <Button
                  htmlType="submit"
                  block
                  size="large"
                  style={{
                     background:
                        "linear-gradient(90deg,#5f3dc4,#7048e8)",
                     border: "none",
                     borderRadius: 30,
                     height: 45,
                     color: "#fff",
                     fontWeight: 500
                  }}
               >
                  Reset password
               </Button>

            </Form>

         </div>
      </div>
   );
};

export default ResetPassword;
